import { connect } from 'react-redux';
import { IState } from '../../../store/index';
import { GalleryPromoTitle, IGalleryPromoTitleProps } from './';

function mapStateToProps(state: IState): IGalleryPromoTitleProps {
  return {
    title: state.offerData.offer.promoLabel,
  };
}

export const PromoContainer = connect(mapStateToProps)(GalleryPromoTitle);
